import { render, staticRenderFns } from "./headerCom.vue?vue&type=template&id=152b11a3&scoped=true"
import script from "./headerCom.vue?vue&type=script&lang=js"
export * from "./headerCom.vue?vue&type=script&lang=js"
import style0 from "./headerCom.vue?vue&type=style&index=0&id=152b11a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b11a3",
  null
  
)

export default component.exports